import { Check, Copy } from "lucide-react";
import { useCallback, useState } from "react";
import { cn } from "@/lib/utils";

export function SetupCopyBlock({
	text,
	prefix,
	multiline,
	className,
}: {
	text: string;
	prefix?: string;
	multiline?: boolean;
	className?: string;
}) {
	const [copied, setCopied] = useState(false);
	const handleCopy = useCallback(async () => {
		await navigator.clipboard.writeText(text);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}, [text]);

	return (
		<button
			type="button"
			onClick={handleCopy}
			className={cn(
				"group relative flex w-full gap-3 rounded-md border border-border bg-white px-4 py-3 text-left font-mono text-sm leading-relaxed text-foreground transition-colors hover:border-foreground/20 hover:bg-white dark:bg-black dark:hover:bg-black",
				multiline ? "items-start" : "items-center",
				className,
			)}
		>
			{prefix ? (
				<span className="select-none text-muted-foreground">{prefix}</span>
			) : null}
			<span
				className={`min-w-0 flex-1 ${multiline ? "whitespace-pre-wrap break-words" : "truncate"}`}
			>
				{text}
			</span>
			<span
				className={`ml-auto inline-flex shrink-0 items-center gap-1 text-xs text-muted-foreground transition-colors group-hover:text-foreground ${multiline ? "mt-[3px]" : ""}`}
			>
				{copied ? (
					<Check className="size-3.5 text-emerald-500" />
				) : (
					<Copy className="size-3.5" />
				)}
			</span>
		</button>
	);
}
